import SlackNotifications from './SlackNotifications';

export default SlackNotifications;
